import React from 'react';
import PropTypes from 'prop-types';

import styles from './CSVModal.module.css';

const FileInputScreen = ({ onChange }) => (
  <div className={styles.content}>
    <i className={`${styles.icon} fal fa-file-upload`} />
    <h2>Choose a File to Upload</h2>
    <label className={styles.button} style={{ width: 150 }} htmlFor="file">
      Browse
      <input id="file" type="file" accept=".csv" onChange={onChange} />
    </label>
  </div>
);

FileInputScreen.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default FileInputScreen;
